<template>
  <div class="min-h-screen flex flex-col">
    <div id="app-content" class="flex-1">
      <router-view />
    </div>
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  name: 'App',
  components: {
    FooterSection
  }
});
</script>
